import { useInjection } from 'inversify-react';
import { IRegionsObserver } from 'controllers/regionsObserver/types';
import { EGlobalDIKeys } from 'core/di/keys';

export const useRegionsObserver = () => {
  return useInjection<IRegionsObserver>(EGlobalDIKeys.RegionsObserver);
};
